import clsx from "clsx";
import { ComponentPropsWithoutRef } from "react";
import "./tableRoot.scss";

interface ITableRootProps extends ComponentPropsWithoutRef<"div"> { }

export const TableRoot = (props: ITableRootProps) => {
    return <div {...props} className={clsx("table-root", props.className)} />;
};
